import React from "react";

// Prevents a single failing section/page from blanking the whole site.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "exception", {
          description: String(error && error.message).slice(0, 150),
          fatal: false,
        });
      }
    } catch (e) {}
  }
  componentDidUpdate(prevProps) {
    // reset when the route changes
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        style={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "14px",
          padding: "120px 20px 40px",
          textAlign: "center",
          background: "#fff6ea",
          fontFamily: "'Playfair Display', serif",
        }}
      >
        <h2 style={{ color: "#921414" }}>Something went wrong</h2>
        <p style={{ fontFamily: "Roboto, sans-serif", color: "#555" }}>
          Please refresh the page, or call us on{" "}
          <a href="tel:+919867711124">+91 98677 11124</a>.
        </p>
        <button
          type="button"
          className="avilbtn avilbtn-2"
          onClick={() => window.location.reload()}
        >
          Refresh page
        </button>
      </div>
    );
  }
}
